module.exports = __webpack_public_path__ + "assets/stability_white.0598ac2c.svg";